// 接口前缀
let baseUrl = '/checkinapi';
// if (process.env.NODE_ENV === "development") {
//   baseUrl = "https://msc.trackin.me"
// } else {
// 	// baseUrl = 'https://msc.trackin.me';
//   baseUrl = '/checkinapi';
//   // baseUrl = 'https://www.msccruises.com.cn';
// }

export default baseUrl


// WEBPACK FOOTER //
// ./src/config/env.js